import { createContext, useContext, type ReactNode } from 'react';

const CustomerShellChromeContext = createContext(false);

/** True when rendered under CustomerAppShell (stable top + bottom chrome). */
export function useCustomerShellChrome(): boolean {
  return useContext(CustomerShellChromeContext);
}

export function CustomerShellChromeProvider({
  children,
}: {
  readonly children: ReactNode;
}): JSX.Element {
  return (
    <CustomerShellChromeContext.Provider value={true}>
      {children}
    </CustomerShellChromeContext.Provider>
  );
}
